import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createRoot } from 'react-dom/client';
import translate from '../../../../translate';
import alarmImg from '../../../../../images/rse/alarm.png';
// Single PDP slot: [data-product-last-call] lives outside the CTA React root.
let lastCallRoot = null;
let lastCallContainer = null;
const LastCallContent = () => (_jsxs("div", { className: "u-flex u-flex-cross-start u-mt-xs-sm", children: [_jsx("img", { src: alarmImg, alt: "", loading: "lazy", className: "u-flex-item-none u-mt-xxs-bis" }), _jsx("p", { className: "u-mt-n u-ml-xs-sm u-text-md-plus u-text-md-plus@sm u-color-gray-700", children: _jsx("em", { children: translate('front.product.index.last_call_message') }) })] }));
export const renderLastCall = () => {
    const container = document.querySelector('[data-product-last-call]');
    if (!container)
        return;
    if (!lastCallRoot || lastCallContainer !== container) {
        lastCallRoot?.unmount();
        lastCallRoot = createRoot(container);
        lastCallContainer = container;
    }
    lastCallRoot.render(_jsx(LastCallContent, {}));
};
export const clearLastCall = () => {
    if (!lastCallRoot)
        return;
    const root = lastCallRoot;
    lastCallRoot = null;
    lastCallContainer = null;
    queueMicrotask(() => {
        try {
            root.unmount();
        }
        catch (error) {
            console.warn('Error while unmounting last call root:', error);
        }
    });
};
